export const DepositApiUrlWithWWW = (
  producttype,
  amount,
  TermYears,
  TermMonths
) => {
  // return `https://www.suryodaybank.com/calculator/deposit-calculator?producttype=${producttype}&amount=${amount}&TermYears=${TermYears}&TermMonths=${TermMonths}`;
  return `https://suryoday.bank.in/calculator/deposit-calculator?producttype=${producttype}&amount=${amount}&TermYears=${TermYears}&TermMonths=${TermMonths}`;
};
export const LoanEmiApiUrlWithWWW = () => {
  // return `https://www.suryodaybank.com/calculator/loan-emi-calculator`;
  return `https://suryoday.bank.in/calculator/loan-emi-calculator`;
};
export const ProdDepositApiUrl = (
  producttype,
  amount,
  TermYears,
  TermMonths
) => {
  // return `https://suryodaybank.com/calculator/deposit-calculator?producttype=${producttype}&amount=${amount}&TermYears=${TermYears}&TermMonths=${TermMonths}`;
  return `https://suryoday.bank.in/calculator/deposit-calculator?producttype=${producttype}&amount=${amount}&TermYears=${TermYears}&TermMonths=${TermMonths}`;
};
export const ProdLoanEmiApiUrl = () => {
  // return `https://suryodaybank.com/calculator/loan-emi-calculator`;
  return `https://suryoday.bank.in/calculator/loan-emi-calculator`;
};

//   ===========   Previoulsy used Url  =================== //

// const encodedUrl = encodeURI(
//   `https://surpaiuat.suryodaybank.co.in/ssfbuat/deposit/${productkey}/${depositAmount}/calculator/v2?Term=${
//     tenureYears ? tenureYears : 0
//   }Y${tenureMonths ? tenureMonths : 0}M&api_key=pszz74m5t93yavg24ba27rv2`
// );
